import React, { useEffect, useState } from 'react';
import { hold, release } from '../../utils/appUpdate';
import { SettingsBtn } from './AppBars';

export function ChatHeader({ title, onHistory, onNewChat, settingsPath }) {
  return (
    <header className="appbar appbar--plain">
      <div className="appbar-row">
        <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 10 }}>
          <span className="ai-avatar" style={{ background: 'var(--brand)', color: '#fff' }}>
            M
          </span>
          <div className="appbar-title">{title}</div>
        </div>
        <div style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', gap: 2 }}>
          {onNewChat && (
            <button
              type="button"
              className="chip"
              style={{ marginRight: 4, padding: '6px 10px', fontSize: 12 }}
              aria-label="新しいチャット"
              onClick={onNewChat}
            >
              新しいチャット
            </button>
          )}
          <button type="button" className="appbar-icon" aria-label="会話履歴" onClick={onHistory}>
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 8v4l3 2" stroke="var(--slate)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M3.5 12a8.5 8.5 0 108.5-8.5A8.5 8.5 0 004.2 8"
                stroke="var(--slate)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M3.6 4v4h4" stroke="var(--slate)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <SettingsBtn to={settingsPath} />
        </div>
      </div>
    </header>
  );
}

export function ChatInput({ placeholder, onSend, disabled }) {
  const [text, setText] = useState('');
  // An unsent draft must survive: hold the silent app-update reload while there is text.
  const hasDraft = text.trim().length > 0;
  useEffect(() => {
    if (!hasDraft) return undefined;
    hold();
    return release;
  }, [hasDraft]);

  const submit = () => {
    const v = text.trim();
    if (!v || disabled) return;
    onSend?.(v);
    setText('');
  };

  return (
    <div className="chat-input">
      <span className="chat-input-plus" aria-hidden="true">
        ＋
      </span>
      <input
        className="chat-input-field"
        placeholder={placeholder}
        aria-label="メッセージ入力"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
        disabled={disabled}
      />
      <button type="button" className="chat-input-send" aria-label="送信" onClick={submit} disabled={disabled || !text.trim()}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 12l16-8-6 16-3-7-7-1z" fill="#fff" />
        </svg>
      </button>
    </div>
  );
}

export function ChatBanner({ icon, title, subtitle = 'AIマネージャーが伴走します' }) {
  return (
    <div className="chat-banner">
      <span className="chat-banner-ic">{icon}</span>
      <div>
        <div className="chat-banner-t">{title}</div>
        <div className="chat-banner-s">{subtitle}</div>
      </div>
    </div>
  );
}
